/**
 * Runtime type guard for {@link PlatformError}.
 *
 * Validates the three mandatory fields (`type`, `title`, `status`) and their
 * primitive types. Optional fields and extensions are not validated — the
 * caller may inspect them as `unknown`.
 */
export function isPlatformError(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const v = value;
    return (typeof v['type'] === 'string' &&
        typeof v['title'] === 'string' &&
        typeof v['status'] === 'number');
}
//# sourceMappingURL=error.js.map